import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { Page, LayoutSideNavigation, TermsAndConditions, TabNav } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

import css from './TermsAndConditionsPage.module.css';
import { useConfiguration } from '../../context/configurationContext';

const TermsAndConditionsPageComponent = props => {
  const { scrollingDisabled, intl } = props;

  const config = useConfiguration();

  const tabs = [
    {
      text: intl.formatMessage({ id: 'PrivacyPolicyPage.privacyTabTitle' }),
      selected: false,
      linkProps: {
        name: 'PrivacyPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'PrivacyPolicyPage.tosTabTitle' }),
      selected: true,
      linkProps: {
        name: 'TermsAndConditionsPage',
      },
    },
  ];
  const siteTitle = config.marketplaceName;
  const schemaTitle = intl.formatMessage(
    { id: 'TermsAndConditionsPage.schemaTitle' },
    { siteTitle }
  );
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: schemaTitle,
  };
  return (
    <Page title={schemaTitle} scrollingDisabled={scrollingDisabled} schema={schema}>
      <LayoutSideNavigation
        topbar={<TopbarContainer currentPage="TermsAndConditionsPage" />}
        footer={<FooterContainer />}
        currentPage="TermsAndConditionsPage"
        sideNav={<TabNav tabs={tabs} rootClassName={css.tabs} tabRootClassName={css.tab} />}
      >
        <div className={css.content}>
          <h1 className={css.heading}>
            <FormattedMessage id="TermsAndConditionsPage.heading" />
          </h1>
          <TermsAndConditions />
        </div>
      </LayoutSideNavigation>
    </Page>
  );
};

const { bool } = PropTypes;

TermsAndConditionsPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const TermsAndConditionsPage = compose(
  connect(mapStateToProps),
  injectIntl
)(TermsAndConditionsPageComponent);

export default TermsAndConditionsPage;
